import(/* webpackMode: "eager" */ "/var/www/vhosts/easybank.tn/dev-partner.easybank.tn-new/src/app/[locale]/error.tsx");
